export default __webpack_public_path__ + "static/media/mega_image_new.03be94a3.png";